export function checkDataLayerAvailable() {
  return typeof dataLayer !== 'undefined' && dataLayer !== undefined;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function dataLayerPushData(dataObject: any) {
  if (!checkDataLayerAvailable()) {
    return;
  }
  return dataLayer.push(dataObject);
}
